<br/><br/>
<h1>{{ 'consultationPublique.pilotage.titre' | translate }}</h1>
<br/>

<!-- FORMULAIRE D’AJOUT / ÉDITION -->
<div class="form-container mb-4">
  <form [formGroup]="formGroup" (ngSubmit)="addOrUpdate()">

      <!-- Ligne Région -->
    <div class="champ-25 mb-3">
      <label class="form-label">
        {{ 'consultationPublique.pilotage.grille.region' | translate }}
      </label>
      <mat-form-field appearance="outline" class="w-100">
        <mat-select multiple formControlName="regions">
          <mat-option *ngFor="let r of toutesLesRegions" [value]="r.valeur">
            {{ r.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="messageerreur" *ngIf="formGroup.get('regions')?.touched && formGroup.get('regions')?.hasError('required')">
        {{ messagesDeValidation.auMoinsUneRegionRequise }}
      </div>
      <div class="messageerreur" *ngIf="formGroup.get('regions')?.hasError('regionDejaUtilisee')">
        {{ messagesDeValidation.regionDejaUtilisee }}
      </div>
    </div>

    <div class="ligne-date">
      <div class="champ-25 mb-3">
        <label class="form-label">
          {{ 'consultationPublique.pilotage.grille.dateDebut' | translate }}
        </label>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput readonly [matDatepicker]="pickerDebut" formControlName="dateDebut">
          <mat-datepicker-toggle matSuffix [for]="pickerDebut"></mat-datepicker-toggle>
          <mat-datepicker #pickerDebut></mat-datepicker>
        </mat-form-field>
        <div class="messageerreur" *ngIf="formGroup.get('dateDebut')?.touched && formGroup.get('dateDebut')?.hasError('required')">
          {{ messagesDeValidation.dateDebutRequise }}
        </div>
      </div>

      <div class="champ-25 mb-3">
        <label class="form-label">
          {{ 'consultationPublique.pilotage.grille.dateFin' | translate }}
        </label>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput readonly [matDatepicker]="pickerFin" formControlName="dateFin">
          <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
          <mat-datepicker #pickerFin></mat-datepicker>
        </mat-form-field>
        <div class="messageerreur" *ngIf="formGroup.get('dateFin')?.touched && formGroup.get('dateFin')?.hasError('required')">
          {{ messagesDeValidation.dateFinRequise }}
        </div>
        <div class="messageerreur" *ngIf="formGroup.touched && formGroup.hasError('dateInvalide')">
          {{ messagesDeValidation.dateDebutSuperieurFin }}
        </div>
      </div>
    </div>

      <!-- Ligne Nom -->
    <div class="champ-100 mb-3">
      <label class="form-label">
        {{ 'consultationPublique.pilotage.grille.nom' | translate }}
      </label>
      <mat-form-field appearance="outline" class="w-100">
        <input matInput formControlName="nom">
      </mat-form-field>
      <div class="messageerreur" *ngIf="formGroup.get('nom')?.touched && formGroup.get('nom')?.hasError('required')">
        {{ messagesDeValidation.nomConsultationRequis }}
      </div>
    </div>

    <!-- Boutons -->
    <div class="buttons-container">
      <button mat-raised-button
        color="secondary"
        type="button"
        class="me-2"
        (click)="clearFormFields()">
        {{ 'sigt.global.boutons.annuler' | translate }}
      </button>
      <button mat-raised-button
        color="primary"
        type="submit"
        [disabled]="!formGroup.valid">
        {{ editingIndex === null
          ? ('sigt.global.boutons.ajouter' | translate)
          : ('sigt.global.boutons.enregistrer' | translate)
        }}
      </button>
    </div>

  </form>
</div>

<div class="toolbar mb-3">
  <button
    mat-icon-button
    color="warn"
    matTooltip="{{ 'consultationPublique.pilotage.grille.tooltipBoutonSupprimer' | translate }}"
    (click)="deleteSelected()"
    [disabled]="!selection.hasValue()">
    <mat-icon>delete</mat-icon>
  </button>
</div>

<table
  mat-table
  [dataSource]="dataSource"
  class="table-container mat-elevation-z8"
  table-layout="fixed">

  <!-- colgroup pour largeur fixe des colonnes -->
  <colgroup>
    <col class="col-select"/>
    <col class="col-regions"/>
    <col class="col-date-debut"/>
    <col class="col-date-fin"/>
    <col class="col-nom"/>
    <col class="col-actions"/>
  </colgroup>

  <!-- COLONNES DATA -->
  <!-- Sélecteur suppression -->
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        (change)="toggleSelection()"
        [checked]="isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (change)="selection.toggle(row)"
        [checked]="selection.isSelected(row)">
      </mat-checkbox>
    </td>
  </ng-container>

  <!-- Régions -->
  <ng-container matColumnDef="regions">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'consultationPublique.pilotage.grille.region' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      <ng-container *ngIf="row.regions?.length; else noRegions">
        <ng-container *ngFor="let code of row.regions; let last = last">
          {{ getDescriptionRegion(code) }}
          <br *ngIf="!last" />
        </ng-container>
      </ng-container>
      <ng-template #noRegions>—</ng-template>
    </td>
  </ng-container>

  <!-- Date début -->
  <ng-container matColumnDef="dateDebut">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'consultationPublique.pilotage.grille.dateDebut' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row.dateDebut | date:'dd MMM yyyy' }}
    </td>
  </ng-container>

  <!-- Date fin -->
  <ng-container matColumnDef="dateFin">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'consultationPublique.pilotage.grille.dateFin' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row.dateFin | date:'dd MMM yyyy' }}
    </td>
  </ng-container>

  <!-- Nom -->
  <ng-container matColumnDef="nom">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'consultationPublique.pilotage.grille.nom' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row.nom }}
    </td>
  </ng-container>

  <!-- Actions (édition) -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'consultationPublique.pilotage.grille.actions' | translate }}
    </th>
    <td mat-cell *matCellDef="let row; let i = index">
      <button
        mat-icon-button
        matTooltip="{{ 'consultationPublique.pilotage.grille.tooltipBoutonModifier' | translate }}"
        (click)="startEdit(row, i)">
        <mat-icon>edit</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr
    mat-header-row
    *matHeaderRowDef="displayedColumns; sticky: true"
    class="table-header">
  </tr>

  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

</table>

<mat-paginator
  [pageSize]="10"
  [pageSizeOptions]="[5,10,20]"
  showFirstLastButtons>
</mat-paginator>
